import { useRef, useEffect } from 'react';

function useLatest(value) {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}

export { useLatest };
//# sourceMappingURL=use-latest.mjs.map
